// Import React hooks
import { useContext, useState } from "react";

// Import context function
import { AuthContext } from "global/context/AuthContext";

// Import api calls
import { 
    getEmailTemplateRender
} from "api/APIStrichCalls"; 

// Import components
import CreateButton from "global/components/CreateButton";
import RichTextInput from "global/components/RichTextInput";
import HelpButton from "global/components/HelpButton";

// Import css
import "./ConnectionPages.css";
import ToggleSwitch from "global/components/ToggleSwitch";
import { LoadingSpinner } from "global/components/loading_ui/LoadingSpinnerAnimation";







// Store the complete order confirmation email HTML as a template literal string
const orderEmailContent = `
    <!DOCTYPE html>
    <html>
        <body>
            <p>
                Your order has been placed.
            </p>
        </body>
    </html>
`;

// Store the shipped email HTML as a template literal string
const shippedEmailContent = `
    <!DOCTYPE html>
    <html>
        <body>
            <p>
                Your order has been shipped.
            </p>
        </body>
    </html>
`;

// Store the shipped email HTML as a template literal string
const cancelledEmailContent = `
    <!DOCTYPE html>
    <html>
        <body>
            <p>
                Your order has been cancelled.
            </p>
        </body>
    </html>
`;

// Store the shipped email HTML as a template literal string
const refundEmailContent = `
    <!DOCTYPE html>
    <html>
        <body>
            <p>
                Your order has been refunded.
            </p>
        </body>
    </html>
`;



// Create the available email template definitions
const emailTemplates = [
    {
        // Identify this as the order confirmation template
        document_key: "order_confirmation",

        // Pretty display name
        name: "Order Confirmation",

        // Store the order confirmation HTML
        content: orderEmailContent,
    },
    {
        document_key: "order_shipped",
        name: "Shipped Confirmation",
        content: shippedEmailContent,
    },
    {
        document_key: "order_cancelled",
        name: "Order Cancellation",
        content: cancelledEmailContent,
    },
    {
        document_key: "order_refunded",
        name: "Order Refund",
        content: refundEmailContent,
    },
];





// Function to render connection pages
const RenderConnectionEmailTemplates = ({ connectionDetails, token, formValues, setFormValues }) => {


    // Store the selected page id
    const [selectedEmailTemplate, setSelectedEmailTemplate] = useState(null);

    

    return (

        <div className="card">

             <div className="card__header">

                <h3>Email Templates <HelpButton section="stores" code="email-templates-and-styling" label="Email Templates and Styling" /></h3>

                <span className="hintText">

                    Manage the style of the emails sent to customers when their orders are placed, shipped or cancelled.

                </span>

            </div>

            <div className="card__content">

                <div className="connectionPages">

                    <div className="connectionPages__layout">

                        <div className="connectionPages__list">

                            {emailTemplates.map((template) => {

                                return (

                                    <div
                                        key={template.document_key}
                                        className={`connectionPages__page-card ${selectedEmailTemplate?.document_key === template?.document_key ? "connectionPages__page-card--selected" : ""}`}
                                        type="button"
                                        onClick={() => setSelectedEmailTemplate(template)} 
                                    >

                                        <span className="connectionPages__page-main">

                                            <span className="connectionPages__page-name">
                                                {template.name}
                                            </span>

                                        </span>

                                    </div>

                                );

                            })}

                        </div>

                        <div className="connectionPages__detail connectionPages__detail--desktop">

                            <RenderEmailTemplateDetail
                                editingEmailTemplate={selectedEmailTemplate}
                            />

                        </div>

                    </div>

                </div>

            </div>

        </div>

    );

};






// Function to render selected page detail
const RenderEmailTemplateDetail = ({
    editingEmailTemplate,
}) => {

    // Get the token from AuthContext
    const { token } = useContext(AuthContext);

    // Flag for viewing the page content as HTML or rendered nicely
    const [viewAsHTML, setViewAsHTML] = useState(false);

    // Order id for rendering the email template
    const [orderID, setOrderID] = useState("");

    // Set loading state
    const [loadingTemplateRender, setLoadingTemplateRender] = useState(false);

    // Store rendered template data
    const [templateRender, setTemplateRender] = useState(null);

    // Store toggle rendered template state
    const [showTemplateRender, setShowTemplateRender] = useState(true);

    


    const handleRenderEmail = async (orderID, documentKey) => {

        // Clear current data
        setTemplateRender(null);

        // Set Loading
        setLoadingTemplateRender(true);

        // Make the call
        const response = await getEmailTemplateRender(token, orderID, documentKey);

        if (response.success) {

            // Update the state
            setTemplateRender(response.results);
            
        } else {

            // Toast error
            console.log("couldn't render template: ", response.error_message);

        }

        // Clear Loading
        setLoadingTemplateRender(false);
    
    };

    // Stop if no page is selected
    if (!editingEmailTemplate) {

        return (

            <div className="connectionPages__empty">
                Select an email to preview or edit.
            </div>

        );

    }

    // Check whether page is fully editable
    const canFullyEditPage = editingEmailTemplate.source === "user";

    return (

        <div className="connectionPages__detail-inner">

            <div className="connectionPages__detail-header horizontal-align-content-center">

                <div>

                    <h3 className="connectionPages__detail-title">
                        {editingEmailTemplate.name}
                    </h3>

                </div>

                <div className="horizontal-align-content-center">

                    <input 
                        value={orderID || ""}
                        placeholder="Enter Order ID to Render"
                        onChange={(e) => setOrderID(e.target.value)}
                        style={{width: "auto"}}                    
                    />

                    <CreateButton 
                        title="Render Email"
                        size="s"
                        onClick={() => handleRenderEmail(orderID, editingEmailTemplate.document_key)}
                    />

                </div>

            </div>

            {/* 
            {!canFullyEditPage ? (

                <div className="connectionPages__notice">
                    This email template is managed by the platform because it may be required for store compliance.
                </div>

            ) : null}
            */}
            
            {canFullyEditPage ? (

                <div className="connectionPages__form">

                    <label className="connectionPages__field">

                        <span className="connectionPages__label">
                            Page type: {editingEmailTemplate?.name}
                        </span>

                    </label>
                    
                    <div className="connectionPages__field">

                        <div className="horizontal-align-content-center flex-justify-left-right">

                            <span className="connectionPages__label">
                                Content
                            </span>

                            <button
                                className="connectionPages__view-toggle"
                                type="button"
                                title={viewAsHTML ? "Display as final view" : "Display as HTML"}
                                onClick={(event) => {

                                    // Stop the click from bubbling to the popup/form
                                    event.stopPropagation();

                                    // Toggle between HTML and editor view
                                    setViewAsHTML((previousValue) => !previousValue);

                                }}
                            >
                                ⇄

                            </button>

                        </div>

                        {viewAsHTML ? 

                            <textarea
                                className="connectionPages__textarea"
                                value={editingEmailTemplate.content || ""}
                                //onChange={(event) => handleEditingEmailTemplateChange("content", event.target.value)}
                            />

                        :

                            <RichTextInput
                                value={editingEmailTemplate.content || ""}
                                //onChange={handleEditingPageContent} 
                                disabled={!canFullyEditPage}
                                placeholder="Enter text..."
                            />

                        }

                    </div>

                </div>
               
            ) : (

                <>

                {loadingTemplateRender && 
                
                    <LoadingSpinner loadingMessage="Generating email..." />

                }

                {!loadingTemplateRender && templateRender && 

                    <ToggleSwitch value={showTemplateRender} size="s" onChange={() => setShowTemplateRender((prev) => !prev)} />

                }

                {!loadingTemplateRender && showTemplateRender ? 

                    <div
                        className="connectionPages__preview"
                        dangerouslySetInnerHTML={{ __html: templateRender?.content || "" }}
                    />

                    :

                    <div
                        className="connectionPages__preview"
                        dangerouslySetInnerHTML={{ __html: editingEmailTemplate?.content || "" }}
                    />

                }
                </>

            )}

        </div>

    );

};

export default RenderConnectionEmailTemplates;